import { Box, Container, Grid, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import Title from 'components/Title';
import { section1Content } from 'utils/content';
import { JackInTheBox } from 'react-awesome-reveal';

const { MainBG, title, description } = section1Content;
const contentList = [
  { title: 'Explore Architecture', des: 'Coming Soon!' },
  { title: 'Build dApps', des: 'Coming Soon!' }
  // { title: 'Mainnet Transaction', des: 'Coming Soon!' }
];

const Section1 = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{ width: '100%', position: 'relative', marginTop: '-50px', padding: '133px 0px 20px' }}
      style={{ background: `url(${MainBG})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
    >
      {/* Content */}
      <Container
        maxWidth="lg"
        sx={{
          height: '80vh',
          mt: 4,
          [theme.breakpoints.up('md')]: { mt: 6 }
        }}
      >
        <Stack sx={{ height: '100%' }} justifyContent="center" textAlign="center">
          <Container maxWidth="lg">
            <Typography variant="h1" sx={{ letterSpacing: '0.02em', mb: 1, fontSize: { xs: '20px', sm: '32px', lg: '68px' }, mt: 4 }}>
              {title}
            </Typography>

            <Container maxWidth="lg" sx={{ mt: 4 }}>
              {/* <Typography variant="h1" sx={{ letterSpacing: '0.02em', mb: 1, fontSize: { xs: '20px', sm: '32px', lg: '48px' } }}>
                {subtitle}
              </Typography> */}
              {/* <Title
                style={{ textAlign: 'left' }}
                // className="subTitle"  fontSize: '30px',
                variant={{ xs: 'h3', sm: 'h3', md: 'h2' }}
                sx={{ letterSpacing: '0.05em', mt: 5 }}
              >
                {subtitle}
              </Title> */}
              <Box display="flex" sx={{ flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'center', md: 'flex-start' } }}>
                <Title
                  style={{ fontSize: '16px', textAlign: 'center' }}
                  variant={{ xs: 'h4', sm: 'h3', md: 'h2' }}
                  sx={{ letterSpacing: '0.05em', mb: { xs: 2, md: 5 }, textAlign: { xs: 'center', md: 'left' } }}
                >
                  {description}
                </Title>
                {/* <Button
                  style={{
                    width: '100%',
                    background: '#fff',
                    color: '#000',
                    fontWeight: 'bold',
                    textTransform: 'none',
                    whiteSpace: 'pre',
                    height: '100%',
                    maxWidth: '136px',
                    fontSize: '12px'
                  }}
                >
                  See it in action
                </Button> */}
              </Box>
            </Container>
            <Typography variant="h1" sx={{ letterSpacing: '0.02em', mb: 1, fontSize: { xs: '16px', sm: '22px', lg: '48px' }, mt: 4 }}>
              Testnet coming soon!
            </Typography>
          </Container>

          <Stack direction={{ xs: 'column', md: 'row' }} alignItems="center" spacing={4} component={JackInTheBox}>
            <Grid container spacing={2} justifyContent={'center'}>
              {contentList.map((item, i) => {
                return (
                  <Grid item xs={12} sm={4} key={i}>
                    <Box
                      style={{
                        background: '#f8edde',
                        // background: 'url(/images/homepage/cardbg.png)',
                        padding: '20px',
                        height: '100%',
                        borderRadius: '10px'
                      }}
                      sx={{
                        transition: 'all 200ms ease-in-out 200ms',
                        cursor: 'pointer',
                        ':hover': {
                          boxShadow: 'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px'
                        }
                      }}
                    >
                      <Box className="displaySpacebetween">
                        <Typography style={{ textAlign: 'left', color: '#000000', fontSize: '20px', fontWeight: 'bold' }} variant="h5">
                          {item.title}
                        </Typography>
                        <img src="/images/homepage/arrow.png" alt="arrowimg" />
                      </Box>
                      <Typography style={{ textAlign: 'left', color: '#CA7729', fontSize: '35px', fontWeight: 'bold' }} variant="h4">
                        {item.des}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Section1;
